import React from "react";
import marked from "marked";
import { addSizeQuery } from "../utils/image";
import { htmlEncode } from "../utils/encode";
import StoreAction from "../constants/store-action";
import { accessoryTotalPrice, formatPrice } from "../utils/helpers";
const markedRenderer = new marked.Renderer();
const linkRenderer = markedRenderer.link;
markedRenderer.link = (href, title, text) => {
    const html = linkRenderer.call(markedRenderer, href, title, text);
    return html.replace(/<a/, '<a target="_blank"');
};
export default (props) => {
    const [isExtended, setIsExtended] = React.useState(false);
    const accessory = props.accessory;
    const ids = [...props.data.chosenAccessories.ids];
    let isChosen = ids.findIndex((id) => id === accessory.id) > -1;
    const setChosen = (isChosen) => {
        const ids = [...props.data.chosenAccessories.ids];
        const foundIdx = ids.findIndex((id) => id === accessory.id);
        if (isChosen && foundIdx < 0) {
            ids.push(accessory.id);
            updateAccessoryIds(ids);
        }
        else if (!isChosen && foundIdx > -1) {
            ids.splice(foundIdx, 1);
            updateAccessoryIds(ids);
        }
    };
    const updateAccessoryIds = (newIds) => {
        props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
            type: "chosenAccessories",
            name: "ids",
            value: newIds,
        });
    };
    const handleMoreInformationClick = () => {
        setIsExtended(!isExtended);
    };
    const assemblyPriceExist = accessory.assemblyPrice !== undefined;
    let totalPrice = accessoryTotalPrice(accessory);
    let heroImgUrlResized = "";
    if (accessory.media.length > 0)
        heroImgUrlResized = addSizeQuery(accessory.media[0].url, 400, 200);
    let logoImgUrlResized = "";
    if (accessory.logoUrl)
        logoImgUrlResized = addSizeQuery(accessory.logoUrl, 100);
    let markdownLongDescription;
    if (accessory.longDescription) {
        const encodedlongDescription = htmlEncode(accessory.longDescription);
        markdownLongDescription = marked(encodedlongDescription, {
            renderer: markedRenderer,
        });
    }
    return (React.createElement("div", { className: "repeat-m" },
        React.createElement("div", { "data-ecom-box": "light", className: isExtended ? "is-extended" : "" },
            React.createElement("div", { className: "box-hero" },
                React.createElement("img", { src: heroImgUrlResized, alt: "", className: "box-hero-img" })),
            React.createElement("div", { className: "repeat-m" },
                React.createElement("div", { "data-ecom-columnrow": "", className: "m-b" },
                    React.createElement("div", { className: "column" },
                        React.createElement("h2", { className: "h6 no-margin" }, accessory.name)),
                    React.createElement("div", { className: "column minimal" },
                        React.createElement("img", { src: logoImgUrlResized, alt: "", className: "l-block" })))),
            React.createElement("div", { className: "repeat-m" },
                React.createElement("div", { className: "font-medium" },
                    formatPrice(totalPrice),
                    " kr"),
                React.createElement("div", { className: "font-size-small" }, assemblyPriceExist ? "Pris inkl. montering" : "Pris")),
            React.createElement("div", { "data-ecom-content": "", className: "repeat-m" },
                React.createElement("p", null, accessory.shortDescription)),
            React.createElement("div", { className: "box-extend" },
                React.createElement("div", { className: "repeat-m" }, markdownLongDescription && (React.createElement("div", { dangerouslySetInnerHTML: {
                        __html: markdownLongDescription,
                    } }))),
                React.createElement("div", { className: "repeat-m" },
                    React.createElement("div", { className: "font-medium" }, "Art.nr."),
                    React.createElement("div", null, accessory.articleNumber)),
                React.createElement("div", { className: "repeat-m" }, accessory.productPageLink && (React.createElement("a", { href: accessory.productPageLink, title: "test", target: "_blank", rel: "noopener noreferrer nofollow", "data-ecom-link": "" },
                    "L\u00E4s mer",
                    React.createElement("i", { className: "icon-link-external m-l-mini" }))))),
            React.createElement("div", { className: "box-footer" },
                React.createElement("div", { "data-ecom-columnrow": "" },
                    React.createElement("div", { className: "column font-size-small" },
                        React.createElement("button", { "data-ecom-link": "", className: "l-block", onClick: handleMoreInformationClick },
                            isExtended ? "Mindre" : "Mer",
                            " information",
                            React.createElement("i", { className: `m-l-mini ${isExtended
                                    ? "icon-chevron-up"
                                    : "icon-chevron-down"}` }))),
                    React.createElement("div", { className: "column" }, isChosen ? (React.createElement("button", { "data-ecom-button": "small light", onClick: () => setChosen(false) },
                        React.createElement("span", { className: "button-section" },
                            React.createElement("i", { className: "icon-check no-margin" })),
                        React.createElement("span", { className: "button-section" }, "Vald"))) : (React.createElement("button", { "data-ecom-button": "small", onClick: () => setChosen(true) },
                        React.createElement("span", { className: "button-section" },
                            React.createElement("i", { className: "icon-plus no-margin" })),
                        React.createElement("span", { className: "button-section" }, "L\u00E4gg till")))))))));
};
